import React, { useEffect, useRef, useState } from "react";
import Loader from "../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { buttons } from "../helpers/data/settingsButtons";
import { get } from "jquery";

const Settings = () => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(true);
	const [settings, setSettings] = useState([]);
	const [inputValues, setInputValues] = useState({});
	const [socialMediaInputValues, setSocialMediaInputValues] = useState({});
	const [fileValues, setFileValues] = useState({}); // State to handle file paths (images/videos)
	const [socialLinks, setSocialLinks] = useState([]);
	const [activeTab, setActiveTab] = useState("general");

	const tabs = [
		{ id: "general", label: "الإعدادات العامة" },
		{ id: "socialMediaLinks", label: "روابط السوشيال ميديا" },
	];

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اعدادات الموقع",
				breadcrumb: "الاعدادات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/settings/main`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(response => {
				const fetchedSettings = response.data.data;
				setSettings(fetchedSettings);

				// Initialize inputValues and fileValues based on fetched settings
				const initialInputValues = {};
				const initialFileValues = {};
				fetchedSettings.forEach(setting => {
					if (setting.type === "file" || setting.type === "video") {
						initialFileValues[setting.name] = setting.value;
					} else {
						initialInputValues[setting.name] = setting.value || "";
					}
				});

				setInputValues(initialInputValues);
				setFileValues(initialFileValues);
				setLoading(false);
			})
			.catch(error => {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});

		axios
			.get(`${process.env.REACT_APP_API_URL}/settings/social`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(response => {
				const fetchedSocialLinks = response.data.data;
				setSocialLinks(fetchedSocialLinks);

				// تحويل الأراي لأوبجكت
				const inputValues = {};
				fetchedSocialLinks.forEach(link => {
					inputValues[link.name] = link.value;
				});

				setSocialMediaInputValues(inputValues);
				setLoading(false);
			})

			.catch(error => {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handleChange = e => {
		const { name, value } = e.target;
		setInputValues(prevValues => ({
			...prevValues,
			[name]: value,
		}));
	};
	const handleSocialMediaInputChange = e => {
		const { name, value } = e.target;
		setSocialMediaInputValues(prevValues => ({
			...prevValues,
			[name]: value,
		}));
	};

	const handleFileChange = (e, type) => {
		const file = e.target.files[0];
		const name = e.target.name;
		const formData = new FormData();
		formData.append("file", file);

		setLoading(true);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				const filePath = response.data.data.name;
				setFileValues(prevValues => ({
					...prevValues,
					[name]: filePath,
				}));
				updateSetting(name, filePath, type);
			})
			.catch(() => {
				toast.error("خطأ في رفع الملف، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	const updateSetting = (name, value, type) => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/settings`,
				{ [name]: value },
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(() => {
				toast.success("تم التحديث بنجاح!");
				setLoading(false);
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();
		const updatedSettings = settings.map(setting => ({
			...setting,
			value: inputValues[setting.name] || fileValues[setting.name] || "",
		}));

		const editedSettings = { ...inputValues };

		setLoading(true);
		axios
			.post(`${process.env.REACT_APP_API_URL}/settings`, editedSettings, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(() => {
				toast.success("تم التحديث بنجاح!");
				setLoading(false);
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};
	const handleSocialMediaSubmition = e => {
		e.preventDefault();

		setLoading(true);
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/settings`,
				socialMediaInputValues,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(() => {
				toast.success("تم التحديث بنجاح!");
				setLoading(false);
			})
			.catch(() => {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	const handleChangeFile = name => {
		setLoading(true);
		const pictureTwo = document.querySelector(`#${name}`);
		const data = new FormData();
		data.append("file", pictureTwo.files[0]);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				axios
					.post(
						`${process.env.REACT_APP_API_URL}/settings`,
						{
							[name]: response.data.data.name,
						},
						{
							headers: {
								Authorization: `Bearer ${cookie.get("token")}`,
								Accept: "application/json",
							},
						}
					)
					.then(function (response) {
						toast.success("تم التحديث بنجاح!");
						const updatedSettings = settings.map(setting => {
							if (
								(setting.name === "appLogo" && name === "appLogo") ||
								(setting.name === "mainBannerImage" &&
									name === "mainBannerImage") ||
								(setting.name === "footerImage" && name === "footerImage") ||
								(setting.name === "favicon" && name === "favicon")
							) {
								return {
									...response.data.data[0],
								};
							}
							return setting;
						});
						setSettings(updatedSettings);
						setLoading(false);
					})
					.catch(function (error) {
						toast.error("خطأ، برجاء المحاولة مره اخرى!");
						setLoading(false);
					});
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	const handleChangeVideo = name => {
		setLoading(true);
		const pictureTwo = document.querySelector(`#${name}`);
		const data = new FormData();
		data.append("file", pictureTwo.files[0]);
		axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				axios
					.post(
						`${process.env.REACT_APP_API_URL}/settings`,
						{
							landingVedio: response.data.data.name,
						},
						{
							headers: {
								Authorization: `Bearer ${cookie.get("token")}`,
								Accept: "application/json",
							},
						}
					)
					.then(function (response) {
						toast.success("تم التحديث بنجاح!");
						const updatedSettings = settings.map(setting => {
							if (setting.name === "landingVedio") {
								return {
									...response.data.data[0],
								};
							}
							return setting;
						});
						setSettings(updatedSettings);
						setLoading(false);
					})
					.catch(function (error) {
						toast.error("خطأ، برجاء المحاولة مره اخرى!");
						setLoading(false);
					});
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};
	return (
		<section className="settings">
			{loading && <Loader />}
			<div className="tabs mb-4">
				{tabs.map(tab => (
					<button
						key={tab.id}
						type="button"
						className={`btn ${activeTab === tab.id ? "active" : ""}`}
						onClick={() => setActiveTab(tab.id)}
					>
						{tab.label}
					</button>
				))}
			</div>
			{activeTab === "general" && (
				<form onSubmit={handleSubmit}>
					<div className="row">
						{!loading &&
							settings.map(setting => (
								<div className="col-md-6" key={setting.name}>
									<div className="form-item">
										<label htmlFor={setting.name}>{setting.trans_name}</label>
										{setting.type === "textarea" ? (
											<textarea
												name={setting.name}
												id={setting.name}
												cols="30"
												rows="3"
												onChange={handleChange}
												value={inputValues[setting.name] || ""}
												dir={
													setting?.name?.split("_")[1] === "EN" ? "ltr" : "rtl"
												}
											/>
										) : setting.type === "select" ? (
											<select
												name={setting.name}
												id={setting.name}
												value={inputValues[setting.name] || ""}
												onChange={handleChange}
											>
												<option value="0">غير مفعل</option>
												<option value="1">مفعل</option>
											</select>
										) : setting.type === "file" ? (
											<>
												<input
													type="file"
													name={setting.name}
													onChange={
														setting.name === "landingVedio"
															? () => {
																	handleChangeVideo(setting.name);
															  }
															: () => handleChangeFile(setting.name)
													}
													id={setting.name}
												/>
												<div className="img-holder">
													{setting.name === "landingVedio" ? (
														<video
															src={
																process.env.REACT_APP_MAIN_URL + setting.value
															}
															style={{ width: "100%" }}
															controls
														/>
													) : setting.name === "appLogo" ||
													  setting.name === "mainBannerImage" ? (
														<img
															src={
																process.env.REACT_APP_MAIN_URL + setting.value
															}
															alt=""
														/>
													) : setting.name === "footerImage" ? (
														<img
															src={
																process.env.REACT_APP_MAIN_URL + setting.value
															}
															alt=""
														/>
													) : setting.name === "favicon" ? (
														<img
															src={
																process.env.REACT_APP_MAIN_URL + setting.value
															}
															alt=""
														/>
													) : null}
												</div>
											</>
										) : (
											<input
												type="text"
												name={setting.name}
												value={inputValues[setting.name] || ""}
												onChange={handleChange}
												id={setting.name}
												dir={
													setting?.name?.split("_")[1] === "EN" ? "ltr" : "rtl"
												}
											/>
										)}
									</div>
								</div>
							))}
					</div>
					<div className="row">
						<div className="col-md-12">
							<button className="bt bt-success">ارسال</button>
						</div>
					</div>
				</form>
			)}

			{activeTab === "socialMediaLinks" && (
				<>
					<form onSubmit={handleSocialMediaSubmition}>
						<div className="row">
							{!loading &&
								socialLinks.map(socialLink => (
									<div className="col-md-6" key={socialLink.name}>
										<div className="form-item">
											<label htmlFor={socialLink.name}>
												{socialLink.trans_name}
											</label>
											<input
												type="text"
												name={socialLink.name}
												value={socialMediaInputValues[socialLink.name] || ""}
												onChange={handleSocialMediaInputChange}
												id={socialLink.name}
												dir="ltr"
											/>
										</div>
									</div>
								))}
						</div>
						<div className="row">
							<div className="col-md-12">
								<button className="bt bt-success">ارسال</button>
							</div>
						</div>
					</form>
				</>
			)}
		</section>
	);
};

export default Settings;
